import update from "immutability-helper";
import { AuthReduxActions } from "./Action";

export interface IProfile {
  userId: string;
  name: string;
  username: string;
  role: string;
  accessToken: string;
  isBlocked: string;
  createdAt: string;
  updatedAt: string;
}

export interface IAuthState {
  isUserLoggedIn: boolean;
  accessToken: string;
  profile?: IProfile;
}

const authState: IAuthState = {
  isUserLoggedIn: false,
  accessToken: "",
};

const AuthStateReducer = (
  state = authState,
  action: any = { type: "", payload: {} }
): IAuthState => {
  switch (action.type) {
    case AuthReduxActions.AUTH_SET_LOGIN_STATUS:
      return update(state, {
        $merge: {
          ...action.payload,
        },
      });
    case AuthReduxActions.LOGOUT:
      return update(state, {
        $merge: {
          ...authState,
        },
      });
    default:
      return state;
  }
};

export default AuthStateReducer;
